import script from "./Banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./Banner.vue?vue&type=script&setup=true&lang=ts"

import "./Banner.vue?vue&type=style&index=0&id=3df4d914&scoped=true&lang=css"

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3df4d914"]])

export default __exports__